import axios from 'axios';
import { optionalEnv, requireEnv } from './env';

const COINGECKO_API_URL = 'https://api.coingecko.com/api/v3/';

export const SERVER_URL = requireEnv('VITE_API_BASE_URL');

export const GET_ETHEREUM_PRICE = `${COINGECKO_API_URL}simple/price?ids=ethereum&vs_currencies=eur`;
export const GET_ETHEREUM_PRICE_HIST = '${COINGECKO_API_URL}coins/ethereum/market_chart/range?vs_currency=eur&from=1727154484&to=1727771753';
export const ADD_ADDRESS = `${SERVER_URL}/add_address`;

export const URLS = {
  GET_ETHEREUM_PRICE,
  GET_ETHEREUM_PRICE_HIST,
  ADD_ADDRESS
};

const coinGeckoApiKey = optionalEnv('VITE_COINGECKO_API_KEY');

export const coinGeckoAxios = axios.create({
  baseURL: COINGECKO_API_URL,
  headers: {
    "accept": "application/json",
    ...(coinGeckoApiKey ? { "x-cg-demo-api-key": coinGeckoApiKey } : {})
  }
});

export const serverAxios = axios.create({
  baseURL: SERVER_URL,
  headers: {
    "Content-Type": "application/json"
  }
});
